<template>
  <div>
    <v-row
      v-if="
        itemIndex !== 0 && !isFinance && group.name !== 'Budget By Taxonomy'
      "
      class="px-2"
      align="center"
    >
      <img
        src="@/assets/images/icon/file-text.png"
        width="18px"
        height="18px"
        class="ml-1"
      />
      <span
        class="
          pl-2
          font-weight-medium
          subtitle-1
          darkblue--text
          fs-14
          font-weight-700
        "
      >
        {{ group.name }}
      </span>
    </v-row>
    <v-flex xs12 class="pt-1 px-0">
      <template>
        <v-simple-table class="spending-table nav-table">
          <template v-slot:default>
            <thead>
              <tr class="primary custom-table-header">
                <th
                  width="41px"
                  style="padding: 0px 17px !important"
                  v-if="page == 'approval'"
                >
                  <v-layout align-center>
                    <label class="form-checkbox">
                      <input
                        class="checkbox-approval"
                        type="checkbox"
                        v-model="group.selectAll"
                        @click="selectAll(group)"
                      />
                      <span class="checkbox-custom"></span>
                    </label>
                  </v-layout>
                </th>
                <th rowspan="2" class="f-14 font-weight-500">Name</th>
                <th rowspan="2" class="f-14 font-weight-500">Group Type</th>
                <th rowspan="2" class="f-14 font-weight-500">Total Budget</th>
                <th rowspan="2" class="f-14 font-weight-500">Total Spending</th>
                <th rowspan="2" class="f-14 font-weight-500">
                  Total Remaining
                </th>
                <th width="70px" v-if="page == 'approval'">Notes</th>
              </tr>
            </thead>
            <v-perfect-scroll
              class="drawer-menu--scroll-group"
              :settings="scrollSettings"
            >
              <tbody v-if="group.children.length > 0">
                <tr
                  v-for="(item, index) in group.children"
                  :key="item.id"
                  style="cursor: pointer"
                  :class="bgActive(groupActive, item, item.status)"
                >
                  <template
                    v-if="item.totalBudget !== 0 || item.totalSpending !== 0"
                  >
                    <td width="41px" v-if="page == 'approval'">
                      <v-layout align-center>
                        <label class="form-checkbox">
                          <input
                            class="checkbox-approval"
                            type="checkbox"
                            :value="item"
                            v-model="group.selected"
                            :id="'group-' + index"
                          />
                          <span class="checkbox-custom"></span>
                        </label>
                      </v-layout>
                    </td>
                    <td class="fs-12" @click="getDetail(item)">
                      {{ item.name }}
                    </td>
                    <td class="text-capitalize fs-12" @click="getDetail(item)">
                      {{ item.type }}
                    </td>
                    <td class="text-right fs-12" @click="getDetail(item)">
                      {{ idr(item.totalBudget) }}
                    </td>
                    <td class="text-right fs-12" @click="getDetail(item)">
                      {{ idr(item.totalSpending) }}
                    </td>
                    <td class="text-right fs-12" @click="getDetail(item)">
                      {{ idr(item.remaining) }}
                    </td>
                    <td
                      width="70px"
                      v-if="page == 'approval'"
                      class="text-center"
                    >
                      <modal-rejectIO
                        :item="item"
                        :type="item.type"
                        :page="page"
                        :listGroup="listGroup"
                      />
                    </td>
                  </template>
                </tr>
                <hr style="border: 0.5px solid rgba(0, 0, 0, 0.08)" />
                <tr style="display: none">
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4" class="text-center pt-2">
                    <span>No Data Displayed</span>
                  </td>
                </tr>
              </tbody>
            </v-perfect-scroll>
          </template>
        </v-simple-table>
        <v-flex
          xs12
          class="text-right px-2 pb-2 pr-0"
          v-if="page == 'approval'"
        >
          <v-btn
            class="ma-2 white--text"
            color="#bd1e19"
            :disabled="group.selected.length < 1"
            @click="reject()"
          >
            Reject
          </v-btn>
          <v-btn
            primary
            class="primary ma-2 mr-0"
            :disabled="group.selected.length < 1"
            @click="approve()"
          >
            Approve
          </v-btn>
        </v-flex>
      </template>
      <template v-if="group.name == 'Budget By Taxonomy'">
        <v-expansion-panels class="mb-8 elevation-0">
          <v-expansion-panel class="elevation-0">
            <v-expansion-panel-header class="pa-0">
              <template v-slot:actions>
                <v-icon medium color="primary" class="mr-2">
                  keyboard_arrow_down
                </v-icon>
              </template>
              <template>
                <v-row no-gutters>
                  <div>
                    <img
                      src="@/assets/logo/git-pull-request.png"
                      width="16px"
                      class="mt-3 mx-1"
                    />
                  </div>
                  <span
                    class="
                      pl-1
                      pt-3
                      pb-2
                      font-weight-medium
                      subtitle-1
                      darkblue--text
                    "
                    style="margin-left: 2px"
                    >Budget By Taxonomy</span
                  >
                </v-row>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0 pb-0 px-0 ma-0">
              <v-row class="pa-0 pb-2">
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="downloadFile(group)">
                  <v-icon size="10px">mdi-download</v-icon>Download
                </v-btn>
              </v-row>
              <v-row class="pa-0">
                <budget-taxonomy
                  :itemData="group"
                  @getSearchBudget="getSearchBudget"
                ></budget-taxonomy>
                <!-- :listTaxo="group.listTaxo"
                  :listBudget="group.taxonomy"
                  :inScopeBudget="group.totalInScopeBudget"
                  :inScopeSpending="group.totalInScopeSpending"
                  :spent="group.totalSpending"
                  :total="group.totalBudget" -->
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row class="px-1 mb-5">
          <v-row no-gutters align="center">
            <img
              src="@/assets/images/icon/briefcase.png"
              class="ml-3"
              width="20px"
              height="20px"
            />
            <span class="pl-2 subtitle-1 darkblue--text fs-14 font-weight-500"
              >Budget Movement</span
            >
          </v-row>
          <v-spacer></v-spacer>
          <v-flex xs1 class="text-right pa-0 ma-0">
            <v-btn
              v-if="hasPermission('create_budget', 'create')"
              text
              icon
              color="primary"
              @click="showDialog()"
            >
              <v-icon>add_circle_outline</v-icon>
            </v-btn>
          </v-flex>
          <budget-movement :budgetMovement="group.budgetMovement">
          </budget-movement>
        </v-row>
        <v-row class="px-1">
          <v-row no-gutters align="center">
            <img
              src="@/assets/images/icon/file-text.png"
              width="18px"
              height="18px"
              class="ml-3"
            />
            <span class="pl-2 subtitle-1 darkblue--text fs-14 font-weight-500"
              >History Log Budget</span
            >
          </v-row>
          <history-budget :historyBudget="group.historyBudget">
          </history-budget>
        </v-row>
      </template>
    </v-flex>
    <!-- add budget movemet -->
    <v-dialog v-model="dialogBudget" scrollable max-width="60%" persistent>
      <v-card>
        <v-card-title class="primary white--text pt-2">
          <span class="pa-0">Budget Movement</span>
        </v-card-title>
        <v-divider></v-divider>
        <VuePerfectScrollbar
          class="drawer-menu--scrollEdit"
          :settings="scrollSettingsEdit"
        >
          <v-container class="pb-0">
            <v-col sm="12" class="text-center">
              <v-tabs v-model="tab" centered>
                <v-tabs-slider></v-tabs-slider>

                <v-tab @click="changeAdd"> Reallocation </v-tab>
                <v-tab @click="changeRealocate"> Add/Cut Budget </v-tab>
              </v-tabs>
            </v-col>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-card-text class="pa-4">
                    <ValidationObserver ref="trfBudget">
                      <v-layout row wrap>
                        <v-flex xs6 class="pr-2">
                          <p class="black--text"><b>Sender</b></p>
                          <label class="darkblue--text">Date</label>
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            :disabled="true"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                dense
                                id="date"
                                v-model="date"
                                label="Date"
                                prepend-inner-icon="event"
                                readonly
                                single-line
                                outlined
                                v-on="on"
                                :disabled="true"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="date" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false"
                                >Cancel</v-btn
                              >
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(date)"
                                >OK</v-btn
                              >
                            </v-date-picker>
                          </v-menu>
                          <ValidationProvider
                            name="Budget Owner"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label class="darkblue--text">Budget Owner</label>
                            <v-autocomplete
                              dense
                              id="budgetOwner"
                              single-line
                              outlined
                              readonly
                              disabled
                              label="Select Budget Owner"
                              v-model="itemTransfer.budget_code_sender"
                              required
                              :items="budgetOwners"
                              item-value="code"
                              item-text="desc"
                              :error-messages="errors"
                              autocomplete="off"
                            ></v-autocomplete>
                          </ValidationProvider>
                          <ValidationProvider
                            name="Taxonomy"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label class="darkblue--text">Taxonomy</label>
                            <v-autocomplete
                              dense
                              id="taxonomy"
                              single-line
                              outlined
                              label="Select Taxonomy"
                              v-model="itemTransfer.taxo_code_sender"
                              required
                              :items="taxonomySender"
                              return-object
                              item-text="desc"
                              :error-messages="errors"
                              autocomplete="off"
                            >
                              <template slot="selection" slot-scope="data">
                                {{ data.item.taxonomy }} - {{ data.item.desc }}
                              </template>
                              <template slot="item" slot-scope="data">
                                {{ data.item.taxonomy }} - {{ data.item.desc }}
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                          <ValidationProvider
                            name="Current Amount"
                            rules="required"
                          >
                            <label class="darkblue--text">Current Amount</label>
                            <v-currency-field
                              id="currentAmountTaxo"
                              label="Current Amount"
                              name="Current Amount Taxo"
                              single-line
                              v-model="itemTransfer.taxo_code_sender.amount"
                              outlined
                              disabled
                            />
                          </ValidationProvider>
                          <ValidationProvider
                            name="Amount"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label class="darkblue--text">Amount</label>
                            <v-currency-field
                              id="amount"
                              label="Amount"
                              single-line
                              v-model="itemTransfer.amount"
                              outlined
                              required
                              :error-messages="errors"
                            />
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs6 class="pl-2">
                          <p class="black--text"><b>Receiver</b></p>
                          <label class="darkblue--text">Date</label>
                          <v-menu
                            ref="menu2"
                            v-model="menu2"
                            :close-on-content-click="false"
                            :return-value.sync="date2"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            :disabled="true"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                id="date"
                                dense
                                v-model="date2"
                                label="Date"
                                prepend-inner-icon="event"
                                readonly
                                single-line
                                outlined
                                v-on="on"
                                :disabled="true"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="date2" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu2 = false"
                                >Cancel</v-btn
                              >
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu2.save(date2)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                          <ValidationProvider
                            name="Budget Owner"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label class="darkblue--text">Budget Owner</label>
                            <v-autocomplete
                              dense
                              @change="getListTaxo(itemTransfer)"
                              id="budgetOwner1"
                              single-line
                              outlined
                              label="Select Budget Owner"
                              v-model="itemTransfer.budget_code_receiver"
                              required
                              :items="budgetOwners"
                              item-value="code"
                              item-text="desc"
                              :error-messages="errors"
                              autocomplete="off"
                            ></v-autocomplete>
                          </ValidationProvider>
                          <ValidationProvider
                            name="Taxonomy"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label class="darkblue--text">Taxonomy</label>
                            <v-autocomplete
                              dense
                              id="taxonomy1"
                              single-line
                              outlined
                              label="Select Taxonomy"
                              v-model="itemTransfer.taxo_code_receiver"
                              required
                              :items="taxonomyReceiver"
                              return-object
                              item-text="desc"
                              :error-messages="errors"
                              autocomplete="off"
                            >
                              <template slot="selection" slot-scope="data">
                                {{ data.item.taxonomy }} - {{ data.item.desc }}
                              </template>
                              <template slot="item" slot-scope="data">
                                {{ data.item.taxonomy }} - {{ data.item.desc }}
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Current Amount"
                            rules="required"
                          >
                            <label class="darkblue--text">Current Amount</label>
                            <v-currency-field
                              id="currentAmountTaxo"
                              label="Current Amount"
                              name="Current Amount Taxo"
                              single-line
                              v-model="itemTransfer.taxo_code_receiver.amount"
                              outlined
                              disabled
                              dense
                            />
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12>
                          <ValidationProvider
                            name="Reason Reallocation"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label class="darkblue--text">Reason</label>
                            <v-text-field
                              dense
                              v-model="itemTransfer.reason"
                              id="reasonreallocation"
                              required
                              outlined
                              placeholder="Reason"
                              single-line
                              :error-messages="errors"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-flex>
                      </v-layout>
                    </ValidationObserver>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-card-text class="pa-4">
                    <ValidationObserver ref="addBudget">
                      <v-row>
                        <v-flex xs12>
                          <label class="darkblue--text">Date</label>
                          <v-menu
                            ref="menu3"
                            v-model="menu3"
                            :close-on-content-click="false"
                            :return-value.sync="date3"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            :disabled="true"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                dense
                                id="date"
                                v-model="date3"
                                label="Date"
                                prepend-inner-icon="event"
                                readonly
                                single-line
                                outlined
                                v-on="on"
                                :disabled="true"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="date3" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu3 = false"
                                >Cancel</v-btn
                              >
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu3.save(date3)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12>
                          <ValidationProvider
                            name="Transaction Type"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label class="darkblue--text"
                              >Transaction Type</label
                            >
                            <v-select
                              dense
                              id="transaction"
                              single-line
                              outlined
                              label="Select Type"
                              v-model="itemAdd.typeTrx"
                              required
                              :items="typeTransactions"
                              item-value="value"
                              item-text="desc"
                              :error-messages="errors"
                            ></v-select>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12>
                          <ValidationProvider
                            name="Budget Owner"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label class="darkblue--text">Budget Owner</label>
                            <v-autocomplete
                              dense
                              id="budgetOwner2"
                              readonly
                              disabled
                              single-line
                              outlined
                              label="Select Budget Owner"
                              v-model="itemAdd.budget_code"
                              required
                              :items="budgetOwners"
                              item-value="code"
                              item-text="desc"
                              :error-messages="errors"
                              autocomplete="off"
                            ></v-autocomplete>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs6>
                          <ValidationProvider
                            name="Taxonomy"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label class="darkblue--text">Taxonomy</label>
                            <v-autocomplete
                              dense
                              id="taxonomy2"
                              single-line
                              outlined
                              label="Select Taxonomy"
                              v-model="itemAdd.taxo"
                              required
                              :items="taxonomySender"
                              return-object
                              item-text="desc"
                              :error-messages="errors"
                              autocomplete="off"
                            >
                              <template slot="selection" slot-scope="data">
                                {{ data.item.taxonomy }} -
                                {{ data.item.desc }}
                              </template>
                              <template slot="item" slot-scope="data">
                                {{ data.item.taxonomy }} -
                                {{ data.item.desc }}
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs6 class="pl-2">
                          <label class="darkblue--text">Current Amount</label>
                          <v-currency-field
                            id="currentAmountTaxo"
                            label="Current Amount"
                            name="Current Amount Taxo"
                            single-line
                            v-model="itemAdd.taxo.amount"
                            outlined
                            disabled
                          />
                        </v-flex>
                        <v-flex xs12>
                          <ValidationProvider
                            name="Amount"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label class="darkblue--text">Add/Cut Amount</label>
                            <v-currency-field
                              id="amount"
                              label="Amount"
                              single-line
                              v-model="itemAdd.amount"
                              outlined
                              required
                              :error-messages="errors"
                            />
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12>
                          <ValidationProvider
                            name="Reason"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label class="darkblue--text">Reason</label>
                            <v-text-field
                              dense
                              v-model="itemAdd.reason"
                              id="reason"
                              required
                              outlined
                              placeholder="Reason"
                              single-line
                              :error-messages="errors"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-flex>
                      </v-row>
                    </ValidationObserver>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        </VuePerfectScrollbar>
        <v-divider></v-divider>
        <v-card-actions class="pr-4" v-if="reallocation === true">
          <v-spacer></v-spacer>
          <v-btn color="#bd1e19" dark @click="closeDialogBudget()">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            dark
            @click="confirmTransfer()"
            class="text-right ml-3"
          >
            Send
          </v-btn>
        </v-card-actions>
        <v-card-actions class="pr-4" v-else>
          <v-spacer></v-spacer>
          <v-btn color="#bd1e19" dark @click="closeDialogBudget()">
            Cancel
          </v-btn>
          <v-btn color="primary" dark @click="confirmAdd()" class="right ml-3">
            {{ itemAdd.typeTrx ? itemAdd.typeTrx : 'Add' }} Budget
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog error approval restriction -->
    <v-dialog v-model="dialogErrorApproval" scrollable max-width="600px">
      <v-card class="py-3 pb-5">
        <v-flex class="text-center">
          <div
            class="swal2-icon swal2-error swal2-animate-error-icon"
            style="display: flex"
          >
            <span class="swal2-x-mark">
              <span class="swal2-x-mark-line-left"></span>
              <span class="swal2-x-mark-line-right"></span>
            </span>
          </div>
          <h2 class="swal2-title" id="swal2-title">Failed!</h2>
          <p></p>
        </v-flex>
        <div class="swal2-content">
          <div id="swal2-content" style="display: block">
            {{ approvalError.message }}
          </div>
        </div>
        <v-expansion-panels
          flat
          class="filterby-info mt-1"
          v-if="approvalError.listBONotApproved"
          v-model="panelListBO"
        >
          <v-expansion-panel>
            <v-expansion-panel-header
              class="primary--text fs-14 d-block text-center"
              height="100px"
            >
              {{ panelListBO === 0 ? 'Hide' : 'Show' }} Budget Owner List
            </v-expansion-panel-header>
            <v-expansion-panel-content class="grey--text">
              <v-simple-table class="spending-table nav-table px-8 mt-5">
                <template v-slot:default>
                  <thead>
                    <tr class="primary custom-table-header">
                      <th class="f-14 font-weight-500">Budget Owner</th>
                      <th class="f-14 font-weight-500">Approval Level</th>
                    </tr>
                  </thead>
                  <v-perfect-scroll
                    class="drawer-menu--scroll-approval"
                    :settings="scrollSettingsApproval"
                  >
                    <tbody v-if="approvalError.listBONotApproved.length > 0">
                      <tr
                        v-for="(item, index) in approvalError.listBONotApproved"
                        :key="'bo' + index"
                      >
                        <td class="fs-12">
                          {{ item.budget_owner }}
                        </td>
                        <td class="text-uppercase fs-12">
                          {{ item.approval_level }}
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="4" class="text-center pt-2">
                          <span>No Data Displayed</span>
                        </td>
                      </tr>
                    </tbody>
                  </v-perfect-scroll>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div class="swal2-actions">
          <button
            type="button"
            class="swal2-confirm swal2-styled"
            style="
              display: inline-block;
              border-left-color: rgb(48, 133, 214);
              border-right-color: rgb(48, 133, 214);
            "
            @click="dialogErrorApproval = false"
          >
            OK
          </button>
        </div>
      </v-card>
    </v-dialog>
    <progress-dialog
      :show="progressDialogLoading"
      text="Please wait"
    ></progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '@/components/progress_dialog';
import BudgetTaxonomy from '@/components/budgetTaxonomy';
import budgetMovement from '@/components/budgetMovement';
import BudgetHistory from '@/components/budgetHistory';
import modalReject from '@/components/approval/modalRejectIO';
import Swal from 'sweetalert2';
import moment from 'moment';
import ACLMixin from '@/mixins/ACLMixin';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    'budget-taxonomy': BudgetTaxonomy,
    'budget-movement': budgetMovement,
    'history-budget': BudgetHistory,
    'modal-rejectIO': modalReject,
    VuePerfectScrollbar
  },
  mixins: [ACLMixin],
  props: {
    group: {
      type: Object,
      required: true
    },
    listGroup: {
      type: Object
    },
    itemIndex: {
      type: Number
    },
    isFinance: {
      type: Boolean
    },
    page: {
      type: String
    },
    groupActive: {
      type: Number
    },
    year: {
      type: Date
    }
  },
  data() {
    return {
      xlxFile: {},
      nameFile: '',
      itemsConvert: [],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        acceptedFiles: '.xlsx',
        maxFiles: 1,
        init: function() {
          this.on('addedfile', function() {
            if (this.files.length > 1) {
              this.removeFile(this.files[0]);
            }
          });
        },
        addRemoveLinks: true,
        dictDefaultMessage:
          '<i class="fas fa-camera"></i><span class="primary--text">Click or Drop Files Here to Upload</span>'
      },
      isDisabled: true,
      manual: true,
      tab: null,
      scrollSettings: {
        maxScrollbarLength: 260
      },
      scrollSettingsEdit: {
        maxScrollbarLength: 220
      },
      scrollSettingsApproval: {
        maxScrollbarLength: 100
      },
      progressDialogLoading: false,
      dialogBudget: false,
      dialogErrorApproval: false,
      panelListBO: null,
      approvalError: {
        message: '',
        listBONotApproved: []
      },
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      date3: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      reallocation: true,
      budgetOwners: [],
      taxonomySender: [],
      taxonomyReceiver: [],
      itemTransfer: {
        budget_code_sender: 0,
        taxo_code_sender: {
          amount: 0,
          desc: '',
          taxonomy: ''
        },
        budget_code_receiver: 0,
        taxo_code_receiver: {
          amount: 0,
          desc: '',
          taxonomy: ''
        },
        amount: 0,
        reason: ''
      },
      itemAdd: {
        budget_code: 0,
        taxo: {
          amount: 0,
          desc: '',
          taxonomy: ''
        },
        amount: 0,
        reason: '',
        type: ''
      },
      tempData: null,
      typeTransactions: [
        { desc: 'Add Budget', value: 'add' },
        { desc: 'Cut Budget', value: 'cut' }
      ],
      baseUrl: process.env.VUE_APP_BASE_URL
    };
  },
  watch: {
    'listGroup.listGroup': {
      deep: true,
      handler() {
        let copyList = this.copy(this.listGroup.listGroup);
        let lastIndex = copyList[copyList.length - 1];
        let isGroup = copyList
          .filter(item => {
            return item.name !== 'Spending by Taxonomy';
          })
          .filter(item => {
            return item.selected.length > 0;
          });
        if (
          isGroup.length > 0 &&
          lastIndex.name === 'Spending by Taxonomy' &&
          lastIndex.selected.length > 0
        ) {
          Swal.fire(
            'Failed!',
            'You already checked Code in Spending By Taxonomy Table. If you want to approve in Group Table, kindly unchecked the Code.',
            'error'
          );
          this.listGroup.listGroup = copyList.map(item => {
            if (item.name !== 'Spending by Taxonomy') {
              item.selectAll = false;
              item.selected = [];
            }
            return item;
          });
          // let list = copyList.listGroup.filter(item => {
          //   return item.name !== 'Spending by Taxonomy';
          // });
          // this.listGroup.listGroup = list.map(item => {
          //   item.selected = [];
          //   return item;
          // });
        }
      }
    },
    'group.selected'() {
      if (this.page !== 'budgeting') {
        if (this.group.selected.length === this.group.children.length) {
          this.group.selectAll = true;
        } else {
          this.group.selectAll = false;
        }
      }
    }
  },
  mounted() {
    // console.log('groups', this.group);
  },
  methods: {
    closeDialogBudget() {
      this.dialogBudget = false;
      this.tab = 0;
    },
    downloadFile(itemFile) {
      let budget_code = itemFile.budgetCode;
      window.open(
        this.baseUrl +
          '/v1/budgets/report/detail/export?profileId=' +
          localStorage.getItem('profile_id') +
          '&budgetCode=' +
          budget_code +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    },
    getSearchBudget(obj) {
      this.$emit('parseParamBudget', obj);
    },
    afterComplete(file) {
      this.isDisabled = false;
      this.xlxFile = file;
      this.nameFile = file.upload.filename;
    },
    parseFile() {
      var fileType = this.nameFile.split('.').pop();
      var fileTypes = ['xlsx', 'xls', 'XLS', 'XLSX'];
      if (fileTypes.includes(fileType)) {
        this.progressDialogLoading = true;
        this.loading = true;
        let formData = new FormData();
        formData.append('budget', this.xlxFile);
        this.$store
          .dispatch('budget/parse', formData)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              this.itemsConvert = data.data;
              this.isDisabled = true;
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        Swal.fire('Failed!', 'Format file must be .xlsx', 'error');
        this.$refs.myVueDropzone.removeAllFiles();
      }
    },
    getTemplate() {
      window.open(
        this.baseUrl +
          '/v1/budgets/template?token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    },
    approve() {
      let text =
        this.group.name !== 'Budget Owner' || this.group.name !== 'House'
          ? this.group.name
          : 'Group';
      Swal.fire({
        title: '',
        text: `Are you sure want to approve this ${text}?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          if (this.listGroup.level === 100 && this.group.name === 'House') {
            this.approveHouse();
          } else {
            this.approveGroupBO();
          }
        }
      });
    },
    reject() {
      let text =
        this.group.name !== 'Budget Owner' || this.group.name !== 'House'
          ? this.group.name
          : 'Group';
      Swal.fire({
        title: '',
        text: `Are you sure want to reject this ${text}?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          if (this.listGroup.level === 100 && this.group.name === 'House') {
            this.rejectHouse();
          } else {
            this.rejectGroupBO();
          }
        }
      });
    },
    approveGroupBO() {
      this.progressDialogLoading = true;
      // filter item sesuai type
      let group = this.group.selected.filter(
        item => item.type !== 'Budget Owner'
      );
      let budgetOwner = this.group.selected.filter(
        item => item.type === 'Budget Owner'
      );
      let params = {
        group_ids: group.map(item => {
          return item.id;
        }),
        budget_owner_ids: budgetOwner.map(item => {
          return item.id;
        }),
        year: moment(this.year).format('YYYY'),
        divisi_id: this.group.idCard,
        house_ids:
          group.length > 0
            ? group[0].house_id
              ? group.map(item => {
                  return item.house_id;
                })
              : null
            : null
      };
      this.$store
        .dispatch('approval/approveGroupBO', params)
        .then(data => {
          this.progressDialogLoading = false;
          this.panel = [];
          if (data.code === 200) {
            Swal.fire({
              title: 'Success!',
              text: data.message.text_en,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.$emit('getData');
              }
            });
          } else {
            if (data) {
              this.dialogApproval(data.response.data);
              // Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.message.text_en, 'error');
          this.$emit('getData');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    approveHouse() {
      this.progressDialogLoading = true;
      let divisi = this.group.selected.map(item => {
        return parseInt(item.division_id);
      });
      let params = {
        house_id: this.group.selected.map(item => {
          return item.house_id;
        }),
        division_id: divisi[0],
        year: moment(this.year).format('YYYY')
      };
      this.$store
        .dispatch('approval/approveHouse', params)
        .then(data => {
          this.progressDialogLoading = false;
          this.panel = [];
          if (data.code === 200) {
            Swal.fire({
              title: 'Success!',
              text: data.message.text_en,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.$emit('getData');
              }
            });
          } else {
            if (data) {
              this.dialogApproval(data.response.data);
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.message.text_en, 'error');
          this.$emit('getData');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    rejectHouse() {
      this.progressDialogLoading = true;
      let divisi = this.group.selected.map(item => {
        return parseInt(item.division_id);
      });
      let params = {
        house_id: this.group.selected.map(item => {
          return item.house_id;
        }),
        division_id: divisi[0],
        year: moment(this.year).format('YYYY')
      };
      this.$store
        .dispatch('approval/rejectHouse', params)
        .then(data => {
          this.progressDialogLoading = false;
          this.panel = [];
          if (data.code === 200) {
            Swal.fire({
              title: 'Success!',
              text: data.message.text_en,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.$emit('getData');
              }
            });
          } else {
            if (data) {
              this.dialogApproval(data.response.data);
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.message.text_en, 'error');
          this.$emit('getData');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    dialogApproval(data) {
      this.approvalError.message = data.message.text_en;
      if (data.data) {
        this.approvalError.listBONotApproved = data.data.listBONotApproved;
      } else {
        this.approvalError.listBONotApproved = [];
      }
      this.dialogErrorApproval = true;
    },
    rejectGroupBO() {
      this.progressDialogLoading = true;

      // filter item sesuai type
      let group = this.group.selected.filter(
        item => item.type !== 'Budget Owner'
      );
      let budgetOwner = this.group.selected.filter(
        item => item.type === 'Budget Owner'
      );
      let params = {
        group_ids: group.map(item => {
          return item.id;
        }),
        budget_owner_ids: budgetOwner.map(item => {
          return item.id;
        }),
        year: moment(this.year).format('YYYY'),
        divisi_id: this.group.idCard,
        house_ids:
          group.length > 0
            ? group[0].house_id
              ? group.map(item => {
                  return item.house_id;
                })
              : null
            : null
      };
      this.$store
        .dispatch('approval/rejectGroupBO', params)
        .then(data => {
          this.progressDialogLoading = false;
          this.panel = [];
          if (data.code === 200) {
            Swal.fire({
              title: 'Success!',
              text: data.message.text_en,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.$emit('getData');
              }
            });
          } else {
            if (data) {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.message.text_en, 'error');
          this.$emit('getData');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    async showDialog() {
      this.tab = 0;
      this.clearForm();
      await this.getListBO();
      this.itemTransfer.budget_code_sender = this.group.budgetCode;
      this.itemAdd.budget_code = this.group.budgetCode;
      await this.getListTaxo(this.itemTransfer);
      this.dialogBudget = true;
    },
    getListBO() {
      this.progressDialogLoading = true;

      let params = {
        year: moment(this.year).format('YYYY')
      };
      this.$store
        .dispatch('budgetMovement/listBO', params)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.budgetOwners = data.data.budgetCodes;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getListTaxo(value) {
      this.progressDialogLoading = true;
      if (value.budget_code_receiver) {
        this.itemTransfer.taxo_code_receiver = {
          amount: 0,
          desc: '',
          taxonomy: ''
        };
        this.taxonomyReceiver = [];
      } else {
        this.taxonomySender = [];
      }
      let budget_code = value.budget_code_receiver
        ? value.budget_code_receiver
        : value.budget_code_sender;
      let params = {
        budget_code: budget_code
      };
      this.$store
        .dispatch('budgetMovement/listTaxo', params)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            if (value.budget_code_receiver) {
              this.taxonomyReceiver = data.data.taxonomyCodes;
            } else {
              this.taxonomySender = data.data.taxonomyCodes;
            }
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    confirmTransfer() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to transfer budget?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.dialogBudget = false;
          this.transferBudget();
        }
      });
    },
    async transferBudget() {
      const validated = await this.$refs.trfBudget.validate();
      if (validated) {
        this.progressDialogLoading = true;

        let params = {
          budget_code_sender: this.itemTransfer.budget_code_sender,
          taxo_code_sender: this.itemTransfer.taxo_code_sender.taxonomy,
          budget_code_receiver: this.itemTransfer.budget_code_receiver,
          taxo_code_receiver: this.itemTransfer.taxo_code_receiver.taxonomy,
          amount: Number(this.itemTransfer.amount),
          reason: this.itemTransfer.reason
        };
        this.$store
          .dispatch('budgetMovement/transferBudget', params)
          .then(data => {
            this.progressDialogLoading = false;
            if (data.code === 200) {
              Swal.fire({
                title: 'Success!',
                text: `${data.message.text_en}`,
                type: 'success',
                showCancelButton: false,
                confirmButtonText: 'OK'
              }).then(result => {
                if (result.value) {
                  this.$emit('getData');
                }
              });
            } else {
              Swal.fire('Failed!', data.data.message.text_en, 'error');
            }
          })
          .catch(error => {
            Swal.fire('Failed!', error.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        Swal.fire('Failed!', 'Please fill the required field!', 'error');
      }
    },
    confirmAdd() {
      Swal.fire({
        title: '',
        text: `Are you sure want to ${this.itemAdd.typeTrx} budget?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.dialogBudget = false;
          this.addBudget();
        }
      });
    },
    async addBudget() {
      const validated = await this.$refs.addBudget.validate();
      if (validated) {
        this.progressDialogLoading = true;
        let params = {
          budget_code: this.itemAdd.budget_code,
          taxo: this.itemAdd.taxo.taxonomy,
          amount: Number(this.itemAdd.amount),
          reason: this.itemAdd.reason,
          typeTrx: this.itemAdd.typeTrx
        };
        this.$store
          .dispatch('budgetMovement/addBudget', params)
          .then(data => {
            this.progressDialogLoading = false;
            if (data.code === 200) {
              Swal.fire({
                title: 'Success!',
                text: `${data.message.text_en}`,
                type: 'success',
                showCancelButton: false,
                confirmButtonText: 'OK'
              }).then(result => {
                if (result.value) {
                  this.$emit('getData');
                }
              });
              // Swal.fire('Success!', data.message.text_en, 'success');
            } else {
              this.closeDialogBudget();
              Swal.fire('Failed!', data.data.message.text_en, 'error');
            }
          })
          .catch(error => {
            this.closeDialogBudget();
            Swal.fire('Failed!', error.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        this.closeDialogBudget();
        Swal.fire('Failed!', 'Please fill the required field!', 'error');
      }
    },
    changeAdd() {
      this.reallocation = true;
    },
    changeRealocate() {
      this.reallocation = false;
    },
    clearForm() {
      this.itemTransfer = {
        budget_code_sender: this.itemTransfer.budget_code_sender,
        taxo_code_sender: {
          amount: 0,
          desc: '',
          taxonomy: ''
        },
        budget_code_receiver: 0,
        taxo_code_receiver: {
          amount: 0,
          desc: '',
          taxonomy: ''
        },
        amount: 0,
        reason: ''
      };
      this.itemAdd = {
        budget_code: this.itemAdd.budget_code,
        taxo: {
          amount: 0,
          desc: '',
          taxonomy: ''
        },
        amount: 0,
        reason: ''
      };
      this.reallocation = true;
      requestAnimationFrame(() => {
        this.$refs.addBudget.reset();
      });
      requestAnimationFrame(() => {
        this.$refs.trfBudget.reset();
      });
    },
    selectAll() {
      this.group.selected = [];
      if (!this.group.selectAll) {
        for (let i in this.group.children) {
          this.group.selected.push(this.group.children[i]);
        }
      }
    },
    bgActive(val1, val, status) {
      let val2 = null;
      if (val.type === 'House') {
        val2 = val.house_id ? val.house_id : val.id;
      } else {
        val2 = val.id;
      }
      if (status && +val1 !== +val2) {
        return 'softpink-bg';
      } else if (status && +val1 === +val2) {
        return 'softpink-bg primary--text';
      } else if (!status && +val1 === +val2) {
        return 'bgTotal';
      }
    },
    bgStatus(val) {
      if (!val) {
        return '';
      } else {
        return 'softpink-bg';
      }
    },
    getDetail(item) {
      this.$emit('getDetailSpending', item);
    }
  }
};
</script>
<style>
tr:hover {
  background-color: #f5f5f5 !important;
}
.drawer-menu--scroll-group {
  max-height: 425px;
  overflow: auto;
}
.drawer-menu--scroll-approval {
  max-height: 135px;
  overflow: auto;
}
</style>
